import { StyledCol } from './Col.styled'

const Col = ({ ...props }) => {
  return <StyledCol {...props} />
}

export default Col
